import styled from 'styled-components';

export const SelectionAreaStyles = styled.div`
	display: flex;
	flex-direction: column;

	& > p:first-of-type {
		margin-bottom: 4px;
	}

	.border-area {
		display: flex;
		flex-direction: column;
		border: 1px solid #666666;
		margin-top: 24px;
	}
`;
